





























import { UiIconButton } from '../components/keen-ui';

export default {
  name: 'lightbox-image',
  props: {
    src: String,
    alt: String
  },
  components: {
    UiIconButton
  },
  computed: {
    computedSrc: function (): string {
      return !this.imageLoadFailed ? this.src : this.imageErrorSrc;
    }
  },
  data: function () {
    return {
      imageErrorSrc: require('../assets/media/image/image-not-found.svg'),
      imageLoadFailed: false,
      isModalOpened: false
    };
  },
  methods: {
    onExternalClick: function (event): void {
      if (!!this.$refs.modal && !this.$refs.modal.contains(event.target)) {
        this.isModalOpened = false;
      }
    },
    onMiniatureClick: function (): void {
      if (!this.imageLoadFailed) {
        this.isModalOpened = true;
      }
    },
    moveModalToMiniature: function (): void {
      const { width, height, top, left } = this.$refs.miniature.getBoundingClientRect();
      this.$refs.modal.style.width = `${ width }px`;
      this.$refs.modal.style.height = `${ height }px`;
      this.$refs.modal.style.top = `${ top + (height / 2) }px`;
      this.$refs.modal.style.left = `${ left + (width / 2) }px`;
    },
    onModalBeforeEnter: function (): void {
      this.moveModalToMiniature();
    },
    onModalEnter: function (modal: HTMLElement): void {
      const { innerWidth, innerHeight } = window;
      requestAnimationFrame(() => {
        modal.style.removeProperty('width');
        modal.style.removeProperty('height');
        modal.style.top = `${ innerHeight / 2 }px`;
        modal.style.left = `${ innerWidth / 2 }px`;
      });
    },
    onModalAfterEnter: function (modal: HTMLElement): void {
      document.addEventListener('click', this.onExternalClick);
      ['top', 'left'].forEach((property: string) => modal.style.removeProperty(property));
    },
    onModalLeave: function (): void {
      this.moveModalToMiniature();
    },
    onModalAfterLeave: function (modal: HTMLElement): void {
      document.removeEventListener('click', this.onExternalClick);
      ['top', 'left'].forEach((property: string) => modal.style.removeProperty(property));
    }
  },
  watch: {
    src: function (): void {
      this.imageLoadFailed = false;
    }
  }
};
